import React, { useState, useEffect, useCallback } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Header from '../../components/headerbar/Header'
import { useParams, useNavigate } from 'react-router-dom'
import {config} from '../../config'
import axios from 'axios'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import Sidebar from '../../components/sidebar/Sidebar'
import moment from 'moment'
import _ from 'lodash'

const statusOptions = [
  {
    id: 1,
    name: 'Pending',
    value: 'pending',
  },
  {
    id: 2,
    name: 'Confirmed',
    value: 'confirmed',
  },
  {
    id: 3,
    name: 'Cancelled',
    value: 'cancelled',
  },
  {
    id: 4,
    name: 'Completed',
    value: 'completed',
  },
]

const ViewAppointment = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const navigate = useNavigate()
  const params = useParams()

  const [appointmentId, setAppointmentId] = useState('')
  const [username, setusername] = useState('')
  const [msg, setMsg] = useState('')
  const [phonenumber, setPhoneNumber] = useState('')
  const [Email, setEmail] = useState('')
  const [address, setAddress] = useState('')
  const [status, setStatus] = useState('')
  const [date, setDate] = useState('')
  const [time, setTime] = useState('')
  const [products, setProducts] = useState([])
  const [comments, setComments] = useState('')
  const [staffValue, setStaffValue] = useState('')
  const [staffListInfo, setStaffListInfo] = useState([])
  const [scheduleStatus, setScheduleStatus] = useState('')
  const [error, setError] = useState('')

  const getStaffData = async () => {
    let staffList = await fetch(config.apiurl + '/staff/getstaff', {
      method: 'get',
    })
    staffList = await staffList.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setStaffListInfo(staffList.data.results)
  }
  useEffect(() => {
    getStaffData()
  }, [])

  const updateStatus = async () => {
    const apiUrl =
      params?.device?.toLowerCase() === 'mobile'
        ? config.apiurl + `/schedule/${params.id}`
        : config.apiurl + `/schedules/${params.id}`

    const data = {
      schedule_status: scheduleStatus,
      comments: comments,
      staff: staffValue,
    }

    if (!staffValue || !comments?.trim() || !scheduleStatus) {
      setError(true)
    } else {
      fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res?.status?.toLowerCase() === 'true') {
            console.log(res)
            navigate('/appointments')
          }
        })
        .catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    }
  }

  // Get mobile appointment api by id
  const getMobileAppointments = useCallback(async () => {
    let appointmentdetails = await fetch(
      config.apiurl + '/schedule/' + params.id,
      {
        method: 'get',
        headers: {
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
    ).catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    appointmentdetails = await appointmentdetails.json()
    setAppointmentId(appointmentdetails?.data[0]?._id)
    setusername(appointmentdetails.data[0].user_id.name)
    setMsg(appointmentdetails.data[0].user_id.message)
    setPhoneNumber(appointmentdetails.data[0].user_id.phone)
    setEmail(appointmentdetails.data[0].user_id.email)
    setAddress(appointmentdetails.data[0].user_id.address)
    setStatus(appointmentdetails.data[0].schedule_status)
    setDate(appointmentdetails.data[0].date)
    setTime(appointmentdetails.data[0].time)
    setProducts(
      appointmentdetails?.data?.[0]?.products
        ? JSON.parse(appointmentdetails?.data?.[0]?.products)
        : []
    )
    !_.isEmpty(appointmentdetails?.data?.[0]?.staff) &&
    setStaffValue(appointmentdetails?.data?.[0]?.staff)
    !_.isEmpty(appointmentdetails?.data?.[0]?.comments) &&
      setComments(appointmentdetails?.data?.[0]?.comments)
    !_.isEmpty(appointmentdetails?.data?.[0]?.schedule_status) &&
      setScheduleStatus(appointmentdetails?.data?.[0]?.schedule_status)
  }, [accesstoken.data.access_token, params.id])
  useEffect(() => {
    params?.device?.toLowerCase() === 'mobile' && getMobileAppointments()
  }, [getMobileAppointments, params?.device])

  // Get web appointment api by id
  const getWebAppointments = useCallback(async () => {
    let appointmentdetails = await fetch(
      config.apiurl + '/schedules/appt/' + params.id,
      {
        method: 'get',
        headers: {
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
    ).catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    appointmentdetails = await appointmentdetails.json()
    setAppointmentId(appointmentdetails?.data[0]?._id)
    setusername(appointmentdetails.data?.[0]?.name)
    setMsg(appointmentdetails.data?.[0]?.message)
    setPhoneNumber(appointmentdetails.data?.[0]?.mobilenum)
    setEmail(appointmentdetails.data[0]?.email)
    setStatus(appointmentdetails.data[0].schedule_status)
    setDate(appointmentdetails.data?.[0].date)
    setTime(appointmentdetails.data?.[0].time)
    setProducts(appointmentdetails?.data?.[0]?.product_id)
    !_.isEmpty(appointmentdetails?.data?.[0]?.staff) &&
      setStaffValue(appointmentdetails?.data?.[0]?.staff)
    !_.isEmpty(appointmentdetails?.data?.[0]?.comments) &&
      setComments(appointmentdetails?.data?.[0]?.comments)
    !_.isEmpty(appointmentdetails?.data?.[0]?.schedule_status) &&
      setScheduleStatus(appointmentdetails?.data?.[0]?.schedule_status)
  }, [accesstoken.data.access_token, params.id])
  useEffect(() => {
    params?.device?.toLowerCase() === 'web' && getWebAppointments()
  }, [getWebAppointments, params?.device])

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-md-8">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Appointment View</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
                    <div className="">
                      <div className="card-body p-3">
                        <div className="row">
                          <div className="numbers">
                            <p
                              className="text-sm mb-0 text-uppercase font-weight-bold"
                              style={{
                                margin: '20px 30px 20px 30px',
                                color: 'black',
                                fontSize: '30px',
                              }}
                            >
                              Customer Details
                            </p>
                            <div className="table-responsive p-5">
                              <Card style={{ width: '18rem' }}>
                                <ListGroup variant="flush">
                                  <ListGroup.Item>
                                    Name: {username}
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    Phone No: {phonenumber}
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    Email: {Email}
                                  </ListGroup.Item>
                                  {params?.device?.toLowerCase() ===
                                    'mobile' && (
                                    <ListGroup.Item>
                                      Address: {address}
                                    </ListGroup.Item>
                                  )}
                                </ListGroup>
                              </Card>
                            </div>
                          </div>
                          {!msg ? null : <div className="numbers">
                            <p
                              className="text-sm mb-0 text-uppercase font-weight-bold"
                              style={{
                                margin: '20px 30px 20px 30px',
                                color: 'black',
                                fontSize: '30px',
                              }}
                            >
                              Message
                            </p>
                            <div className="table-responsive p-5">
                              <Card style={{ width: '18rem' }}>
                                <ListGroup variant="flush">
                                  <ListGroup.Item>
                                    {msg}
                                  </ListGroup.Item>
                                </ListGroup>
                              </Card>
                            </div>
                          </div>}
                          <div>
                            <p
                              className="text-sm mb-0 text-uppercase font-weight-bold"
                              style={{
                                margin: '20px 30px 20px 30px',
                                color: 'black',
                                fontSize: '30px',
                              }}
                            >
                              Appoinment Details
                            </p>
                            <div className="table-responsive p-5">
                              <Card style={{ width: '18rem' }}>
                                <ListGroup variant="flush">
                                  <ListGroup.Item>
                                    Date:{' '}
                                    {params?.device?.toLowerCase() === 'mobile'
                                      ? moment(date).format('DD-MM-YYYY')
                                      : date}
                                  </ListGroup.Item>
                                  <ListGroup.Item>Time: {time}</ListGroup.Item>
                                  <ListGroup.Item>
                                    Status: {status}
                                  </ListGroup.Item>
                                </ListGroup>
                              </Card>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 d-flex align-items-center">
                  <p
                    className="text-sm mb-0 text-uppercase font-weight-bold"
                    style={{
                      margin: '20px 30px 20px 30px',
                      color: 'black',
                      fontSize: '30px',
                    }}
                  >
                    Product Details
                  </p>
                </div>
                <div className="table-responsive p-5">
                  <table className="table align-items-center mb-0 ">
                    <thead>
                      <tr>
                        <th className="text-secondary opacity-7 ps-2">S.No</th>
                        <th className="text-secondary opacity-7">Image</th>
                      </tr>
                    </thead>

                    <tbody>
                      {params?.device?.toLowerCase() === 'mobile' ? (
                        products &&
                        products.map((item, index) => (
                          <tr key={item._id}>
                            <td>{index + 1}</td>
                            <td>
                              {item.image?.map((data) => (
                                <img
                                  src={config.fileurl + item.image?.filename}
                                  className="avatar avatar-sm me-3"
                                  alt={'img'}
                                  width={40}
                                  height={40}
                                />
                              ))}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td>{1}</td>
                          <td>
                            <p>name : {products?.name}</p>
                            {products?.image?.map((data) => (
                              <img
                                src={
                                  config.fileurl + products.image?.[0]?.filename
                                }
                                // className="avatar avatar-sm me-3"
                                alt={'img'}
                                width={120}
                                height={100}
                              />
                            ))}
                            <p style={{ paddingBlockStart: 8 }}>
                              SKUID : {products?.skuid}
                            </p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Update status */}
            <div className="col-md-4">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Update Status</h6>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Staff
                        </label>
                        <select
                          className="form-control"
                          value={staffValue}
                          onChange={(e) => setStaffValue(e.target.value)}
                        >
                          <option value={""} defaultValue={""}>Choose Staff Name</option>
                          {staffListInfo.map((stf) => (
                            <option value={stf._id} key={stf._id}>
                              {stf.name}- {stf.staffid}
                            </option>
                          ))}
                        </select>
                        {error && !staffValue && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the staff
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          required=""
                          className="form-control-label"
                        >
                          Comments
                        </label>
                        <textarea
                          className="form-control"
                          name="stsComments"
                          value={comments}
                          onChange={(e) => setComments(e.target.value)}
                        ></textarea>
                        {error && !comments?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the comments
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Status
                        </label>
                        <select
                          className="form-control"
                          name="status"
                          value={scheduleStatus}
                          onChange={(e) => setScheduleStatus(e.target.value)}
                        >
                          {statusOptions?.map((data) => (
                            <option value={data?.value} key={data?.id}>
                              {data?.name}
                            </option>
                          ))}
                        </select>
                        {error && _.isEmpty(scheduleStatus) && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the status
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="text-end">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm ms-auto mt-5"
                        onClick={updateStatus}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <ToastContainer /></main>
    </>
  )
}

export default ViewAppointment
